import { gql } from '@apollo/client';

export const STYLE_SUGGESTION = gql`
    query LocationsQuery($index: String!, $query: String!, $filters: String!, $facets: [String]!) {
        locationsInRadius
            @algolia(
                __typename: "styles_query_suggestions"
                index: $index
                filters: $filters
                hitsPerPage: 20
                query: $query
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
